import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import classes from './addRowModalBPMByPillCount.module.scss';
import { toast } from 'react-toastify';

interface FormData {
  productPillCount: number;
  controllingMachineBpm: number;
}

interface AddRowModalDefaultBpmByPillCountProps {
  visible: boolean;
  onHide: () => void;
  onSubmit: (formData: FormData) => Promise<void>;
  initialValues?: FormData;
  isEdit?: boolean;
}

const AddRowModalDefaultBpmByPillCount = ({
  visible,
  onHide,
  onSubmit,
  initialValues,
  isEdit
}: AddRowModalDefaultBpmByPillCountProps) => {
  const [formData, setFormData] = useState<FormData>({
    productPillCount: 0,
    controllingMachineBpm: 0
  });

  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (initialValues && visible) {
      setFormData({ ...initialValues });
      setErrors({});
    } else if (!isEdit && visible) {
      // Reset form for new entry
      setFormData({
        productPillCount: 0,
        controllingMachineBpm: 0
      });
      setErrors({});
    }
  }, [initialValues, visible, isEdit]);

  const validateForm = () => {
    const newErrors: Record<string, string> = {};

    // Required fields
    if (
      formData.productPillCount === null ||
      formData.productPillCount === undefined ||
      formData.productPillCount === 0
    ) {
      newErrors.productPillCount = 'Pill Count is required';
    } else if (formData.productPillCount < 0) {
      newErrors.productPillCount = 'Pill Count cannot be negative';
    }

    if (
      formData.controllingMachineBpm === null ||
      formData.controllingMachineBpm === undefined ||
      formData.controllingMachineBpm === 0
    ) {
      newErrors.controllingMachineBpm = 'Controlling Machine BPM is required';
    } else if (formData.controllingMachineBpm < 0) {
      newErrors.controllingMachineBpm = 'Controlling Machine BPM cannot be negative';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      try {
        await onSubmit(formData);
        // Only close modal on success
        onHide();
      } catch (error) {
        // Don't close modal on error - error will be shown in toast
        if (import.meta.env.VITE_ENVIRONMENT === 'development') {
          console.error('Error submitting form:', error);
        }
        toast.error('Error submitting form for BPM by Pill Count');
      }
    }
  };

  const handleInputChange = (field: keyof FormData, value: any) => {
    setFormData({ ...formData, [field]: value });

    // Clear error when field is updated
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  return (
    <Dialog
      header={isEdit ? 'Edit Default BPM By Pill Count' : 'Add New Default BPM By Pill Count'}
      visible={visible}
      onHide={onHide}
      className={classes.modal}
      style={{ width: '500px' }}
    >
      <div className={classes.formContainer}>
        <div className={classes.formGroup}>
          <label>Pill Count</label>
          <InputText
            value={formData.productPillCount.toString()}
            onChange={e =>
              handleInputChange('productPillCount', parseInt(e.target.value || '0', 10))
            }
            keyfilter="pint"
            placeholder="Enter pill count"
            className={`${classes.inputText} ${errors.productPillCount ? 'p-invalid' : ''}`}
          />
          {errors.productPillCount && <small className="p-error">{errors.productPillCount}</small>}
        </div>

        <div className={classes.formGroup}>
          <label>Controlling Machine BPM</label>
          <InputText
            value={formData.controllingMachineBpm.toString()}
            onChange={e =>
              handleInputChange('controllingMachineBpm', parseInt(e.target.value || '0', 10))
            }
            keyfilter="pint"
            placeholder="Enter controlling machine BPM"
            className={`${classes.inputText} ${errors.controllingMachineBpm ? 'p-invalid' : ''}`}
          />
          {errors.controllingMachineBpm && (
            <small className="p-error">{errors.controllingMachineBpm}</small>
          )}
        </div>

        {/* <div className={classes.formGroup}>
          <label>Efficiency (%)</label>
          <InputText
            value={formData.efficiency.toString()}
            onChange={e => {
              const value = parseInt(e.target.value || '0', 10);
              if (isNaN(value) || value <= 100) {
                handleInputChange('efficiency', value);
              }
            }}
            keyfilter="pint"
            placeholder="Enter efficiency (0-100)"
            className={`${classes.inputText} ${errors.efficiency ? 'p-invalid' : ''}`}
          />
          {errors.efficiency && <small className="p-error">{errors.efficiency}</small>}
        </div>

        <div className={classes.formGroup}>
          <label>Actual BPM</label>
          <InputText
            value={formData.actualBpm.toString()}
            onChange={e => handleInputChange('actualBpm', parseInt(e.target.value || '0', 10))}
            keyfilter="pint"
            placeholder="Enter actual BPM"
            className={`${classes.inputText} ${errors.actualBpm ? 'p-invalid' : ''}`}
          />
          {errors.actualBpm && <small className="p-error">{errors.actualBpm}</small>}
        </div> */}
      </div>

      <div className={classes.modalFooter}>
        <Button label="Cancel" icon="pi pi-times" onClick={onHide} severity="danger" text />
        <Button
          label="Save"
          icon="pi pi-check"
          onClick={handleSubmit}
          className={classes.saveButton}
        />
      </div>
    </Dialog>
  );
};

export default AddRowModalDefaultBpmByPillCount;
